module.exports = __webpack_public_path__ + "static/media/healthy-gray.4941ec47.svg";